import { useState, useEffect, useCallback } from 'react';
import { fetchCanales } from '../utils/api';

/**
 * Fetches all enabled tenants with their broadcast channels.
 * @param {number} [dbIndex]
 */
export function useCanales(dbIndex) {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchCanales(dbIndex);
      setTenants(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [dbIndex]);

  useEffect(() => { load(); }, [load]);

  return { tenants, loading, error, refetch: load };
}
